import { useTranslation } from "react-i18next";

const TextareaError = ({ textareaHasError }) => {
    const { t } = useTranslation();

    return (
        <div className={`flex flex-row gap-1 ${textareaHasError ? "" : " invisible"}`}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                className="size-6 stroke-red-500"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
                />
            </svg>
            <p className="text-red-500">{t("textarea.error.empty")}</p>
        </div>
    );
};

export default TextareaError;
